import React from 'react'
import cn from 'classnames'
import { Arrow } from '../Arrow'
import styles from './DropdownHeader.module.css'

type Props = {
  className?: string
  arrowClassName?: string
  onClick?: () => void
  isActive?: boolean
  shouldShowArrow?: boolean
  isSmall?: boolean
}

export const DropdownHeader: React.FC<Props> = ({
  className,
  arrowClassName,
  isSmall,
  onClick,
  isActive,
  shouldShowArrow = true,
  children
}) => {
  return (
    <div className={cn([styles.root, className])} onClick={onClick}>
      {children}
      {shouldShowArrow && (
        <div className={styles.arrowWrapper}>
          <Arrow
            className={cn(
              styles.arrow,
              isSmall && styles.isSmall,
              arrowClassName
            )}
            isUp={isActive}
          />
        </div>
      )}
    </div>
  )
}
